import uiRouter from '@uirouter/angularjs';

import { AppShellComponent } from './appShell.component';

export const AppShellModule = angular
    .module('app.pages.appShell', [
        uiRouter,
        AppShellComponent
    ]).config(($stateProvider) => {
        'ngInject';

        $stateProvider
            .state({
                name: 'apps',
                parent: 'auth',
                url: '/apps',
                data: {
                    page: 'apps'
                },
                abstract: true,
                template: '<ui-view />'
            });
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/appShell/appShell.module.js